import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {observer} from 'mobx-react';

import {cn} from 'spa/css';

import './Button.less';

@observer
class Button extends React.Component {
  static propTypes = {
    block: PropTypes.bool,
    caps: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    extraRounded: PropTypes.bool,
    isLoading: PropTypes.bool,
    label: PropTypes.string.isRequired,
    notRounded: PropTypes.bool,
    size: PropTypes.oneOf(['normal', 'small', 'tiny', 'micro']),
    tag: PropTypes.oneOf(['button', 'submit', 'link', 'a']),
    theme: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'success', 'transparent', 'facebook', 'paypal', 'hero']).isRequired,
    wide: PropTypes.bool,
  };
  static defaultProps = {
    extraRounded: false,
    tag: 'button',
    size: 'normal',
    caps: true,
    wide: false,
  };

  render() {
    const {
      block,
      caps,
      className,
      disabled,
      extraRounded,
      isLoading,
      label,
      notRounded,
      size,
      tag,
      theme,
      wide,
      ...rest
    } = this.props;
    let _props;
    let Tag;

    switch (tag) {
    case 'submit':
      Tag = 'input';
      _props = {type: 'submit', value: label};
      break;
    case 'link':
      Tag = Link;
      _props = {children: label};
      break;
    case 'a':
    case 'button':
    default:
      Tag = tag;
      _props = {children: label};
      break;
    }

    return (
      <Tag
        {...rest}
        {..._props}
        disabled={(tag === 'submit' || tag === 'button') && disabled}
        className={cn(
          `button button--${theme}`,
          extraRounded && 'button--extra-rounded',
          notRounded && ' button--not-rounded',
          wide && 'button--wide',
          block && ' button--block',
          disabled && ' button--disabled',
          caps && ' button--caps',
          size && ` button--${size}`,
          isLoading && 'button--loading',
          className,
        )}
      />
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./spa/Components/Button.jsx